/* Killer Golf — fit-quiz cart orphan cleanup
 *
 * fit-quiz adds 6 line items per build (head + kit + 4 options). Component lines are
 * tagged `fit-quiz-component` and hidden from the cart drawer / cart page Liquid.
 *
 * Problem: hidden components have no remove UI. If the user deletes the visible head
 * line, the components stay behind as orphan lines the customer can't see or remove.
 *
 * Solution: after every cart-mutating API call (and on page load), scan the cart for
 * component lines whose parent head (same `_kgBuildId`) is missing, and bulk-remove
 * them. The cart drawer / page then re-renders cleanly.
 *
 * Note: head quantity is locked to 1 in the cart UI (see snippets/cart-mini-item.liquid)
 * to prevent qty mismatch between head and components. To buy two putters, the customer
 * runs the fit-quiz twice — each run creates a separate build with a unique _kgBuildId.
 */
(function () {
  if (window.__kgCartCleanupInstalled) return;
  window.__kgCartCleanupInstalled = true;

  var HEAD_HANDLES = ['the-wing', 'the-blade'];
  var IN_FLIGHT = false;
  var LAST_RUN = 0;
  var DEBOUNCE_MS = 200;

  function isHead(item) {
    return HEAD_HANDLES.indexOf(item.handle) !== -1;
  }

  function isComponentLine(item) {
    return Boolean(item.properties && item.properties._kgBuildId && !isHead(item));
  }

  function getBuildId(item) {
    return item.properties && item.properties._kgBuildId ? item.properties._kgBuildId : null;
  }

  function findOrphanKeys(cart) {
    var items = (cart && cart.items) || [];
    if (items.length === 0) return [];

    var headBuilds = {};
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var bid = getBuildId(it);
      if (bid && isHead(it)) headBuilds[bid] = true;
    }

    var orphanKeys = [];
    for (var j = 0; j < items.length; j++) {
      var item = items[j];
      if (!isComponentLine(item)) continue;
      var b = getBuildId(item);
      if (!headBuilds[b]) orphanKeys.push(item.key);
    }
    return orphanKeys;
  }

  function refreshCartSections(result) {
    try {
      if (result && result.sections) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: result }));
      }
    } catch (e) {}
  }

  function cleanupOrphans() {
    if (IN_FLIGHT) return Promise.resolve();
    var now = Date.now();
    if (now - LAST_RUN < DEBOUNCE_MS) return Promise.resolve();
    LAST_RUN = now;
    IN_FLIGHT = true;

    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var orphanKeys = findOrphanKeys(cart);
        if (orphanKeys.length === 0) return null;

        var updates = {};
        for (var i = 0; i < orphanKeys.length; i++) updates[orphanKeys[i]] = 0;

        var body = { updates: updates };
        var sectionsParam = [];
        if (document.querySelector('xo-cart-mini')) sectionsParam.push('xo-cart-mini');
        if (sectionsParam.length) {
          body.sections = sectionsParam;
          body.sections_url = window.location.pathname;
        }

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (result) {
            refreshCartSections(result);
            return result;
          });
      })
      .catch(function (err) {
        console.error('[kg-cart-cleanup] failed:', err && err.message);
      })
      .then(function (result) {
        IN_FLIGHT = false;
        return result;
      });
  }

  var origFetch = window.fetch;
  var CART_MUTATING_RE = /\/cart\/(change|update|add|clear)(?:\.js)?(?:\?|$)/;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = origFetch.apply(this, arguments);
    if (CART_MUTATING_RE.test(url)) {
      result.then(function () {
        setTimeout(cleanupOrphans, DEBOUNCE_MS);
      }).catch(function () {});
    }
    return result;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanupOrphans);
  } else {
    setTimeout(cleanupOrphans, 0);
  }

  window.__kgCleanupOrphans = cleanupOrphans;
})();
